import Link from 'next/link';
import { ComponentPropsWithoutRef, ReactNode } from 'react';

interface NextLinkProps extends ComponentPropsWithoutRef<typeof Link> {
	children: ReactNode;
}

export const NextLink = ({ children, ...props }: NextLinkProps) => {
	return <Link {...props}>{children}</Link>;
};
